import React, { useMemo } from 'react';
import { useProjectStore } from '../../hooks/useProjectStore';
import { useMechProfile, MTH } from './mechShared';
import DepthProfile, { Track } from './DepthProfile';

// /mechanics/stress — 三向地应力剖面 + 水平应力差/各向异性
export default function MechStressPage() {
  const { currentProject } = useProjectStore();
  const { data, loading } = useMechProfile(currentProject?.id);

  // 应力范围自适应
  const sMax = useMemo(() => {
    const vals = data.flatMap((p) => [p.sigma_v, p.sigma_h, p.sigma_h_max].filter((x): x is number => x != null));
    return vals.length ? Math.ceil(Math.max(...vals) / 10) * 10 + 10 : 120;
  }, [data]);

  const tracks: Track[] = [
    {
      title: '三向主应力', unit: 'MPa', min: 0, max: sMax,
      series: [
        { label: 'σv', color: '#2C3E50', accessor: (p) => p.sigma_v },
        { label: 'σH', color: '#C2533A', accessor: (p) => p.sigma_h_max },
        { label: 'σh', color: '#2874A6', accessor: (p) => p.sigma_h },
      ],
    },
    {
      title: '水平应力差 σH−σh', unit: 'MPa', min: 0, max: 20,
      series: [{ label: 'Δσ', color: '#D4770C', accessor: (p) => (p.sigma_h_max != null && p.sigma_h != null ? p.sigma_h_max - p.sigma_h : null) }],
    },
    {
      title: '应力各向异性 (σH−σh)/σh', unit: '', min: 0, max: 0.5,
      series: [{ label: 'Kh', color: '#6A4C93', accessor: (p) => (p.sigma_h_max != null && p.sigma_h ? (p.sigma_h_max - p.sigma_h) / p.sigma_h : null) }],
    },
  ];

  if (!currentProject) return <div style={{ padding: 40, color: MTH.textSec }}>请先选择项目</div>;

  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', background: MTH.bg, fontFamily: 'inherit' }}>
      <div style={{ padding: '8px 20px', borderBottom: `1px solid ${MTH.headerBorder}`, display: 'flex', alignItems: 'center', gap: 12 }}>
        <h2 style={{ fontSize: 15, fontWeight: 700, color: MTH.text, margin: 0 }}>三向地应力剖面</h2>
        <span style={{ fontSize: 12, color: MTH.textMuted }}>
          {loading ? '加载中…' : 'σv 垂向 / σH 最大水平 / σh 最小水平 · 应力差越小越易形成复杂缝网'}
        </span>
      </div>
      <div style={{ flex: 1, minHeight: 0, padding: '4px 8px' }}>
        {!loading && data.length === 0
          ? <div style={{ padding: 40, color: MTH.textMuted, textAlign: 'center' }}>无地应力数据 — 请先导入</div>
          : <DepthProfile points={data} tracks={tracks} />}
      </div>
    </div>
  );
}
